import { useParams } from 'react-router-dom';
import { EUrlParams } from 'config/Urls.config';
import FEATURES_CONFIG from 'config/features';

const useIsExpressCheckout = () => {
  const { type } = useParams() as any;
  return FEATURES_CONFIG.settings.expressChekout && type === EUrlParams.EXPRESS;
};

export default useIsExpressCheckout;
